export const MATERIAL_TEXTS = {
  destinationScope: 'Ámbito',
  title: 'Stock y compras | Tablero de materiales',
  loading: 'Cargando…',
  error: 'No se pudo consultar el tablero.',
  retry: 'Reintentar',
  refresh: 'Actualizar valoración',
  clear: 'Limpiar filtros',
  info: 'Alcance de la valoración',
  scope:
    'Costos de materiales con IVA, sin fletes adicionales. Reservado: estimación FIFO. Físico y libre: existencia global al corte actual.',
  source: 'Fuente de actualización: DolarApi · MEP/Bolsa venta',
  valuedAsOf: 'Valorizado al',
  noQuote: 'Sin cotización disponible',
  coverage: (lines, unvalued) => `${lines} renglones · ${unvalued} sin valorar`,
  nextDelivery: 'Próxima entrega',
  noCommitment: 'Sin compromiso informado',
  knownSubtotal: 'Subtotal conocido',
  stageCosts: 'Costos por etapa',
  materialsByProject: 'Materiales por vivienda',
  providerDelays: 'Proveedores: atrasos y vencidos',
  pesos: 'Pesos',
  delivered: 'Entregado',
  reservedEstimated: 'En depósito (estimado)',
  toArrive: 'Por llegar',
  overdueCount: 'Pendientes vencidos',
  lateCount: 'Completados tarde',
  period: 'Período',
  dateField: 'Campo de fecha',
  dateFrom: 'Desde',
  dateTo: 'Hasta',
  pesosBasis: 'Base en pesos',
  project: 'Vivienda',
  articleSearch: 'Material',
  warehouse: 'Depósito',
  group: 'Grupo',
  provider: 'Proveedor',
  tableColumn: 'Columna',
  comparison: 'Comparación',
  exactValue: 'Valor exacto',
  rawValue: 'Valor sin formato',
  dateValue: 'Fecha',
  apply: 'Aplicar',
  clearColumnFilters: (count) => `Limpiar (${count})`,
};

export const DASHBOARD_TAB_KIND = {
  summary: 'summary',
  report: 'report',
  summaryTable: 'summaryTable',
};

/**
 * Una pestaña = una sola vista. `reportView` es la vista de `material_reports` que la alimenta;
 * `summaryKey` toma la tabla de la respuesta del resumen; `selectFilter` es el filtro que se
 * aplica al hacer clic en una fila.
 */
export const DASHBOARD_TABS = [
  { value: 'summary', label: 'Resumen', kind: DASHBOARD_TAB_KIND.summary },
  {
    value: 'lines',
    label: 'Renglones',
    kind: DASHBOARD_TAB_KIND.report,
    reportView: 'lines',
    columns: 'lines',
  },
  {
    value: 'overdue',
    label: 'Entregas vencidas',
    kind: DASHBOARD_TAB_KIND.report,
    reportView: 'overdue',
    columns: 'purchases',
  },
  {
    value: 'materials',
    label: 'Por material',
    kind: DASHBOARD_TAB_KIND.report,
    reportView: 'articles',
    columns: 'articles',
    selectFilter: 'uuid_inventory_article',
  },
  {
    value: 'projects',
    label: 'Por vivienda',
    kind: DASHBOARD_TAB_KIND.report,
    reportView: 'projects',
    columns: 'projects',
    selectFilter: 'uuid_project',
  },
  {
    value: 'inventory',
    label: 'Existencia',
    kind: DASHBOARD_TAB_KIND.report,
    reportView: 'inventory',
    columns: 'inventory',
  },
  {
    value: 'providers',
    label: 'Por proveedor',
    kind: DASHBOARD_TAB_KIND.report,
    reportView: 'providers',
    columns: 'providers',
    selectFilter: 'uuid_provider_legal_entity',
  },
  {
    value: 'purchases',
    label: 'Compras',
    kind: DASHBOARD_TAB_KIND.report,
    reportView: 'article-costs',
    columns: 'purchases',
  },
];

export const PROJECT_DRILL_TAB = 'materials';
export const PROVIDER_DRILL_TAB = 'purchases';

export const DEFAULT_PERIOD = 'all';
export const CUSTOM_PERIOD = 'custom';

export const INITIAL_MATERIAL_DASHBOARD_FILTERS = {
  valuation_basis: 'current_ars',
  date_field: 'required',
};

export const DATE_FIELDS = [
  { value: 'ordered', label: 'Pedido' },
  { value: 'required', label: 'Necesidad' },
  { value: 'commitment', label: 'Compromiso' },
  { value: 'receipt', label: 'Recepción' },
  { value: 'dispatch', label: 'Despacho' },
];

export const PERIODS = [
  { value: 'all', label: 'Todo el período' },
  { value: '30', label: 'Últimos 30 días' },
  { value: '60', label: 'Últimos 60 días' },
  { value: '90', label: 'Últimos 90 días' },
  { value: 'month', label: 'Este mes' },
  { value: 'previous', label: 'Mes anterior' },
  { value: CUSTOM_PERIOD, label: 'Personalizado' },
];

export const VALUATION_BASIS_OPTIONS = [
  { value: 'current_ars', label: 'Equivalente actualizado' },
  { value: 'historical_ars', label: 'Pesos originales' },
];

export const COLUMN_FILTER_OPERATORS = [
  { value: 'eq', label: 'Igual a', symbol: '=' },
  { value: 'contains', label: 'Contiene', symbol: 'contiene' },
  { value: 'gt', label: 'Mayor a', symbol: '>' },
  { value: 'gte', label: 'Mayor o igual a', symbol: '>=' },
  { value: 'lt', label: 'Menor a', symbol: '<' },
  { value: 'lte', label: 'Menor o igual a', symbol: '<=' },
];

export const COLUMN_FILTER_KIND = {
  text: 'text',
  number: 'number',
  date: 'date',
};

/** Operadores que la API acepta según el tipo de la columna. */
export const COLUMN_FILTER_OPERATORS_BY_KIND = {
  [COLUMN_FILTER_KIND.text]: ['eq', 'contains'],
  [COLUMN_FILTER_KIND.number]: ['eq', 'gt', 'gte', 'lt', 'lte'],
  [COLUMN_FILTER_KIND.date]: ['eq', 'gt', 'gte', 'lt', 'lte'],
};

export const KPI_LABELS = {
  requested_amount: 'Pedido total',
  reserved_amount: 'Comprometido en depósito',
  pending_amount: 'Por llegar',
  delivered_amount: 'Entregado neto',
  returned_amount: 'Devuelto de obra',
  consumed_amount: 'Salida física neta',
  purchase_amount: 'Comprado',
};

export const STAGE_KEYS = [
  'requested_amount',
  'reserved_amount',
  'pending_amount',
  'delivered_amount',
];

export const CHART_TICK_FONT_SIZE = 12;
export const CHART_LABEL_MAX_LENGTH = 18;

export const DESTINATION_SCOPE_OPTIONS = [
  { value: 'all', label: 'Todos los destinos' },
  { value: 'project', label: 'Viviendas' },
  { value: 'internal', label: 'Uso interno' },
];
